import React from 'react'

import PortalModal from "./PortalModal"

import SmartTabs from "../Tabs";
import NewUpload from "../asset-manager/NewUpload";
import Assets from "../asset-manager/Assets";
import Icons from "../asset-manager/Icons";
import StockImages from "../asset-manager/StockImages";
import URL from "../asset-manager/URL";

const IMAGE_OPTIONS = [
  "New Upload",
  "Assets",
  "Stock Images",
  "URL"
]

export default class AssetManagerModal extends React.Component {
  constructor(props){
    super(props)

    this.state = {
      type: props.type,
    }
  }

  componentDidMount(){

  }

  componentWillReceiveProps(nextProps){
    this.setState(nextProps)
  }

  _renderTab(tab){
    let {
      type
    } = this.state

    switch (tab) {
      case 'New Upload': return <NewUpload svgOnly={this.props.svgOnly} onUploaded={(image) => this.props.onSelected(image)}/>
      case 'Assets': return <Assets svgOnly={this.props.svgOnly} onSelected={(image) => this.props.onSelected(image)} />
      case 'Stock Images': return <StockImages type={type} onSelected={(image) => this.props.onSelected(image)} />
      case 'URL': return <URL onSave={(image) => this.props.onSelected(image)} />
      default:    return null
    }
  }

  render() {
    let {
      show,
    } = this.state

    let className = `modal-asset-manager main-container ${this.props.modalClassName} `
    let title = "Asset Manager"

    return (
      <PortalModal
        show={show}
        modalClasses={className}
        showAsSideMenu={"false"}
        contentContainerClassName={""}
        onHide={() => this.props.onHide()}
        showTopOfAll={true}
      >
        <h3>{title}</h3>
        <SmartTabs
          tabs={this.props.svgOnly ? IMAGE_OPTIONS.slice(0, 2) : IMAGE_OPTIONS}
          activeTabIndex={0}
          renderTab={(tab) => this._renderTab(tab)}
        />
      </PortalModal>
    )
  }
}

AssetManagerModal.defaultProps = {
  type: "photo",
  primaryColor: "#6c63ff"
}
